module.exports = __webpack_public_path__ + "static/media/desk_laptop.dde4fbe4.jpg";